"use client";

import clsx from "clsx";
import { twMerge } from "tailwind-merge";

import Circle from "../shapes/circle";
import Rectangle from "../shapes/rectangle";
import Triangle from "../shapes/triangle";
import Polygan from "../shapes/polygan";

function Pattern02({ className = "" }) {
  return (
    <div
      className={twMerge(
        clsx(
          "absolute grid grid-cols-7 gap-3 md:gap-6 stroke-palette-secondary-2",
          className,
        ),
      )}>
      <Circle className="opacity-50 w-4 md:w-6" />
      <div className="w-4 md:w-6"></div>
      <Rectangle
        className="animated stroke-palette-primary-2 w-4 md:w-6"
        isAnimated={true}
      />
      <div className="w-4 md:w-6"></div>
      <Rectangle className="opacity-50 w-4 md:w-6" />
      <Triangle
        className="animated stroke-palette-primary-1 w-4 md:w-6"
        isAnimated={true}
      />
      <Circle className="opacity-50 w-4 md:w-6" />
      <div className="w-4 md:w-6"></div>
      <div className="w-4 md:w-6"></div>
      <div className="w-4 md:w-6"></div>
      <Polygan
        className="animated stroke-palette-primary-2 w-4 md:w-6"
        isAnimated={true}
      />
      <Rectangle className="opacity-50 w-4 md:w-6" />
      <Triangle
        className="animated stroke-palette-primary-2 w-4 md:w-6"
        isAnimated={true}
      />
      <Polygan className="opacity-50 w-4 md:w-6" />
      <div className="w-4 md:w-6"></div>
      <div className="w-4 md:w-6"></div>
      <Triangle
        className="animated stroke-palette-primary-1 w-4 md:w-6"
        isAnimated={true}
      />
      <Polygan className="opacity-50 w-4 md:w-6" />
      <Triangle
        className="animated stroke-palette-primary-2 w-4 md:w-6"
        isAnimated={true}
      />
      <div className="w-4 md:w-6"></div>
      <div className="w-4 md:w-6"></div>
      <Rectangle className="opacity-50 w-4 md:w-6" />
      <Circle className="opacity-50 w-4 md:w-6" />
      <Circle className="opacity-50 w-4 md:w-6" />
      <div className="w-4 md:w-6"></div>
      <div className="w-4 md:w-6"></div>
      <Triangle
        className="animated stroke-palette-primary-1 w-4 md:w-6"
        isAnimated={true}
      />
      <Rectangle className="opacity-50 w-4 md:w-6" />
      <Polygan
        className="animated stroke-palette-primary-2 w-4 md:w-6"
        isAnimated={true}
      />
      <div className="w-4 md:w-6"></div>
      <div className="w-4 md:w-6"></div>
      <div className="w-4 md:w-6"></div>
      <Polygan className="opacity-50 w-4 md:w-6" />
      <Rectangle className="opacity-50 w-4 md:w-6" />
      <Triangle
        className="animated stroke-palette-primary-2 w-4 md:w-6"
        isAnimated={true}
      />
      <div className="w-4 md:w-6"></div>
      <div className="w-4 md:w-6"></div>
      <Circle className="opacity-50 w-4 md:w-6" />
      <Polygan
        className="animated stroke-palette-primary-1 w-4 md:w-6"
        isAnimated={true}
      />
      <div className="w-4 md:w-6"></div>
      <div className="w-4 md:w-6"></div>
      <Rectangle className="opacity-50 w-4 md:w-6" />
      <Triangle
        className="animated stroke-palette-primary-2 w-4 md:w-6"
        isAnimated={true}
      />
    </div>
  );
}

export default Pattern02;
